import "./index.css";
import dayjs from "dayjs";
import { CalendarIcon } from "../../icons";

const ISO = "YYYY-MM-DD";

/** The prescription line: FROM – TO as two native date fields inside one printed box. */
function DateRange({ startDate, numberOfDays, onSetDateRange }) {
  const from = dayjs(startDate);
  const to = from.add(Number(numberOfDays) - 1, "day");

  const update = (nextFrom, nextTo) => {
    if (!nextFrom.isValid() || !nextTo.isValid()) return;
    if (nextTo.isBefore(nextFrom, "day")) nextTo = nextFrom;
    onSetDateRange([nextFrom, nextTo]);
  };

  const openPicker = (event) => {
    const input = event.currentTarget;
    if (typeof input.showPicker === "function") {
      try { input.showPicker(); } catch (_) { /* some browsers throw when not user-activated */ }
    }
  };

  return (
    <div className="Rx" role="group" aria-label="Date range">
      <CalendarIcon className="Rx-icon" />
      <label className="Rx-field">
        <span className="sr-only">From</span>
        <input
          type="date"
          value={from.format(ISO)}
          onChange={(e) => update(dayjs(e.target.value), to)}
          onFocus={openPicker}
          required
        />
      </label>
      <span className="Rx-dash" aria-hidden="true">–</span>
      <label className="Rx-field">
        <span className="sr-only">To</span>
        <input
          type="date"
          value={to.format(ISO)}
          min={from.format(ISO)}
          onChange={(e) => update(from, dayjs(e.target.value))}
          onFocus={openPicker}
          required
        />
      </label>
      <span className="Rx-days">{numberOfDays} {Number(numberOfDays) === 1 ? "day" : "days"}</span>
    </div>
  );
}

export default DateRange;
